import address from './address';

interface AddressItem {
  id: number;
  pid: number;
  name: string;
  children?: AddressItem[];
}

/**
 * 根据地址ID查找地址名称
 * @param id 地址ID
 * @returns 地址名称，如果未找到则返回ID字符串
 */
export const getAddressName = (id: number): string => {
  const findInArray = (items: AddressItem[]): string => {
    for (const item of items) {
      if (item.id === id) {
        return item.name;
      }
      if (item.children) {
        const found = findInArray(item.children);
        if (found) return found;
      }
    }
    return '';
  };
  return findInArray(address) || String(id);
};

/**
 * 获取完整的地址路径
 * @param id 地址ID
 * @returns 完整的地址路径，如：北京市/海淀区
 */
export const getFullAddress = (id: number): string => {
  const path: string[] = [];
  const findPath = (items: AddressItem[], targetId: number): boolean => {
    for (const item of items) {
      if (item.id === targetId) {
        path.unshift(item.name);
        return true;
      }
      if (item.children && findPath(item.children, targetId)) {
        path.unshift(item.name);
        return true;
      }
    }
    return false;
  };
  
  findPath(address, id);
  return path.join('/');
};

/**
 * 批量转换地址ID为地址名称
 * @param ids 地址ID数组
 * @returns 地址名称数组
 */
export const getAddressNames = (ids: number[]): string[] => {
  return ids.map(id => getAddressName(id));
};